import { Component, OnInit } from '@angular/core';
import {
	FormControl,
	FormGroup,
	Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';

import { User } from 'src/app/shared/models/security/user';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { RestitutionPrestation } from 'src/app/shared/models/restitutionPrestation';
import { Prestation, PrestationType } from 'src/app/shared/models/prestation';
import { NotificationEmail, SendEmail } from 'src/app/shared/models/notificationEmail';
import { NotificationType, NotificationTypeEnum } from 'src/app/shared/enums/notification-type.enum';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-restitutionPrestation-modal-ajout',
	templateUrl: './restitutionPrestation-modal-ajout.component.html',
	styleUrls: ['./restitutionPrestation-modal-ajout.component.scss']
})
export class RestitutionPrestationModalAjoutComponent implements OnInit {
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };
	isAddressSelected: { value: boolean } = { value: false };

	LABEL_INTERVENANT: string;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+$");
	PHONE_NUMBER_PATTERN = '0{1}[0-9]{9}';

	form: FormGroup = new FormGroup(
		{
			dateValidQualif: new FormControl<Date>(null),
			dateButoirDepot: new FormControl<Date>(null),
			dateDepotRestFinale: new FormControl<Date>(null),
			type: new FormControl(''),
			prolongation: new FormControl(''),
			dateDemarrage: new FormControl<Date>(null),
			date1erRv: new FormControl<Date>(null),
			dateFinPrev: new FormControl<Date>(null),
			heuresPrev: new FormControl(''),
			totalHeures: new FormControl(''),
			heuresBilaterales: new FormControl(''),
			heuresCollectif: new FormControl(''),
			heuresEmployeur: new FormControl(''),
			totalHeuresRestantes: new FormControl(''),
			mobilisationAutreAs: new FormControl(''),
			raisonSocialeAutre: new FormControl(''),
			pointVigilance: new FormControl(''),
			organismePecBenef: new FormControl(''),
			consequencesHandicap: new FormControl(''),
			reponsesIdentifiees: new FormControl(''),
			aidesTechniques: new FormControl(''),
			aidesHumaines: new FormControl(''),
			aidesOrganisationnelles: new FormControl(''),
			mediation: new FormControl(''),
			statutDemandeProlongation: new FormControl(''),
			demarcheAdministrative: new FormControl(''),
			demarcheAdministrativeDetails: new FormControl(''),
			consequencesPrecoAides: new FormControl(''),
			institutionsPrisEnCharge: new FormControl(''),
			pointsVigilence: new FormControl('')
		}
	);

	prestation: Prestation = null;
	prestationQualif: Prestation = null;
	user: User;
	restitutionPrestation = new RestitutionPrestation();
	notificationEmail : NotificationEmail;
	listNotificationType = NotificationType;
	sendMail = new SendEmail();

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		public bsModalRef: BsModalRef,
		private dateUtils: DateUtils
	) {}

	ngOnInit(): void {
		this.LABEL_INTERVENANT = this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
		this.user = this.facade.dataStorageService.getUser();
		if (this.user) {
			//this.center = this.user.restitutionPrestation.serviceCenter;
		}

		const prestationId = +this.router.url.split('/').pop();
		this.facade.prestationService
			.getPrestationById(prestationId)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
				this.prestationQualif = prestation;
			});

		if(this.prestation?.typePrestation != PrestationType.QD){
			this.facade.prestationService
			.getPrestationById(this.prestation.idQualification)
			.subscribe((prestation: Prestation) => {
				this.prestationQualif = prestation;
			});
		}

		

		console.log(this.prestation);
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.restitutionPrestation.prestation = this.prestationQualif;
		this.facade.restitutionPrestationService.addRestitutionPrestation(this.restitutionPrestation).subscribe({
			complete: () => {
				this.bsModalRef.hide();
				this.isValidateButtonClicked.value = false;
				this.reload();
				// this.facade.notificationEmailService.getAllNotificationEmail().subscribe({
				// 	next: (val) => {
				// 		this.notificationEmail = val.find(x => x.type == this.listNotificationType.SUIVI_DELAI_MISSION)
				// 		this.sendMail.email = this.restitutionPrestation.intervenant.email;
				// 		this.sendMail.notificationEmail = this.notificationEmail;
				// 		this.sendMail.prestation = this.prestation;
				// 		this.facade.notificationEmailService.sendEmail(this.sendMail).subscribe({
				// 			complete: () =>{
				// 				this.bsModalRef.hide();
				// 				this.isValidateButtonClicked.value = false;
				// 			}
				// 		})
				// 	}
				// })
			},
			error: (err: ErrorResponse) => {
				this.isValidateButtonClicked.value = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message,
					err.status
				);
			}
		});

	}
}

